import { useCreateOrUpdateTirageInExhibition } from "@/api/related-fields";
import { FieldConfig } from "@/config/forms/general";
import { TirageInExhibition } from "@/lib/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import LinksDrawerLayout from "./LinksDrawerLayout";

const TirageInExhibitionDrawer = ({
  fields,
  data,
  queryId,
  type,
}: {
  fields: FieldConfig[] | undefined;
  data: TirageInExhibition;
  queryId: string;
  type: string;
}) => {
  const schema = z.object({
    tirageDansExpositionsDescriptionNumeroCatalogue: z.string().optional(),
    tirageDansExpositionsNotes: z.string().optional(),
    exhibition: z.object({
      expositionsDescriptionNumeroExpo: z.string(),
      expositionsDescriptionResume: z.string(),
    }),
  });

  const { mutate: createOrUpdateTirageInExhibition } =
    useCreateOrUpdateTirageInExhibition(queryId, type);

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: {
      exhibition: data.exhibition,
      tirageDansExpositionsDescriptionNumeroCatalogue:
        data.tirageDansExpositionsDescriptionNumeroCatalogue,
      tirageDansExpositionsNotes: data.tirageDansExpositionsNotes,
    },
  });

  const onSubmit = (formData: z.infer<typeof schema>) => {
    createOrUpdateTirageInExhibition({
      id: data.id ?? "",
      tirageDansExpositionsDescriptionNumeroCatalogue:
        formData.tirageDansExpositionsDescriptionNumeroCatalogue,
      tirageDansExpositionsNotes: formData.tirageDansExpositionsNotes,
      tirageId: data.tirage.id,
      exhibitionId: data.exhibition.id,
    });
  };

  return (
    <LinksDrawerLayout
      form={form}
      fields={fields ?? []}
      recordId={data.id}
      onSubmit={onSubmit}
    />
  );
};

export default TirageInExhibitionDrawer;
